@use '../../../../../scss/settings/colors.scss';

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 191px);
  padding: 0;

  .topBar {
    position: absolute;
    top: 0;
    right: 8px;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: -47px;
  }

  .headerActions {
    display: flex;
    align-items: center;

    .actionButton {
      padding: 1px;
      color: colors.$gray-variant-16;

      svg {
        width: 20px;
        height: 20px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }

  }

  .createButton {
    background-color: colors.$purple-light-4;
    color: colors.$base-black;
    text-transform: none;
    font-family: 'Light Inter', sans-serif;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    display: flex;
    padding: 4px 10px;
    align-items: center;
    gap: 10px;
    box-shadow: none;

    &:hover {
      background-color: colors.$purple-light-2;
    }
  }

  .mainContent {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    //align-items: center;
    height: 100%;
    padding: 0;

    .main_container {
      height: 100%;
      //overflow: auto;
      flex-grow: 1;

      &.w_50 {
        flex-shrink: 0;
        max-width: 50% !important;
        width: 50% !important;
      }

    }

  }

  .documentPreview {
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-image: url('../../../../../assets/images/document.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}

.frame {
  height: 100%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  border: none;
}